export default {
  sampleImage: '/data/images/320x212.jpg',
  logoImage: '/data/images/logo.png',
};
